import { useHistory } from 'react-router-dom';
import { ArrowBackIosOutlined } from '@material-ui/icons';

import { useStyles } from './styles';
import themes from 'styles/themes';
import SidebarIcon from '../../assets/svg/sidebar.svg';
import styles from './styles.module.scss';
import TaffiIconWhite from '../../assets/svg/Taffi_Icon_White.svg';
import utils from 'utils/utils';
import ChatCompose from 'component/chat_side_bar/ChatCompose';

export default function ChatHeader({ isStylistView, setIsOpen, handleNewConversation, isOpen }) {
    const classes = useStyles();
    const history = useHistory();

    return (
        <div className={classes.headerSpacing}>
            <div
                className={classes.sideBarIconContainer}
                onClick={() => {
                    if (isStylistView) {
                        history.goBack();
                    } else {
                        setIsOpen(true);
                    }
                }}
            >
                <span
                    style={{
                        color: `${themes.palette.primary.main}`,
                        cursor: 'pointer',
                    }}
                >
                    {isStylistView ? (
                        <ArrowBackIosOutlined />
                    ) : (
                        <img src={SidebarIcon} className={styles.sidebarIcon} alt="side" />
                    )}
                </span>
            </div>
            <div className={classes.headerContainer} style={{ flex: 1, justifyContent: 'center' }}>
                <img src={TaffiIconWhite} alt="Taffi" height={32} width={32} />
                <div className={classes.headerTitle}>Amira</div>
            </div>
            <div
                style={{
                    width: 30,
                    height: 30,
                    marginRight: `${utils.isAppInWidgetMode() ? '22px' : '10px'}`,
                    visibility: isOpen ? 'hidden' : 'visible',
                }}
            >
                <ChatCompose handleNewConversation={handleNewConversation} />
            </div>
        </div>
    );
}
